/********************************************
 * Dependencies from other libs and components
 *******************************************/

// === General Libraries & Functions
//
//  import ReactDOM from 'react-dom';
//  import update from 'immutability-helper';
//
import React, { useState, useEffect } from 'react';
import { ORDER_QTY_LEVELS, INSPECTION_LEVELS, AQL_LIMITS } from "../../reduxRoot/reducers/aqlCalculatorReducer";
import {connect} from "react-redux";
import * as aqlCalculatorActions from '../../reduxRoot/actions/aqlCalculatorActions';
import { numberWithCommas } from '../../utils/helperUtils';


// === Local Libraries & Functions
//
//  import { wrapStore } from '../../utils/reducerUtils';
//  import { initStore } from './store';
//

const qtyOptions = ORDER_QTY_LEVELS.map(({min, max}, i) => (
  <option key={i} value={min}>
    {max === Infinity ? `${numberWithCommas(min)} and over` : `${numberWithCommas(min)} - ${numberWithCommas(max)}`}
  </option>
));

const levelOptions = Object.keys(INSPECTION_LEVELS).map((lvl, i) => (
  <option key={i} value={lvl}>
    {INSPECTION_LEVELS[lvl]}
  </option>
));

const aqlLimitOptions = AQL_LIMITS.map((limit, i) => (
  <option key={i} value={limit}>
    {limit}
  </option>
));


/********************************************
 * Main Component
 *******************************************/

const Form = ({
  // Redux State
  aqlLimitMajor,
  aqlLimitMinor,
  inspectionLevel,
  minOrderQty,

  // Redux Actions
  setAqlLimitMajor,
  setAqlLimitMinor,
  setInspectionLevel,
  setMinOrderQty,
}) => {

  return (
    <section className={'aql-calc-form'}>
      <label>How many pieces are in this production lot?
        <select value={minOrderQty} onChange={(evt) => setMinOrderQty(evt.target.value)}>
          {qtyOptions}
        </select>
      </label>

      <label>What inspection level should be followed?
        <select value={inspectionLevel} onChange={(evt) => setInspectionLevel(evt.target.value)}>
          {levelOptions}
        </select>
      </label>

      <label>AQL limit for <b>major</b> defects
        <select value={aqlLimitMajor} onChange={(evt) => setAqlLimitMajor(evt.target.value)}>
          {aqlLimitOptions}
        </select>
      </label>

      <label>AQL limit for <b>minor</b> defects
        <select value={aqlLimitMinor} onChange={(evt) => setAqlLimitMinor(evt.target.value)}>
          {aqlLimitOptions}
        </select>
      </label>
    </section>
  );
};

export default connect(
  ({ aqlCalculator: { aqlLimitMajor, aqlLimitMinor, inspectionLevel, minOrderQty } }) => ({ aqlLimitMajor, aqlLimitMinor, inspectionLevel, minOrderQty }),
  {
    setAqlLimitMajor: aqlCalculatorActions.setAqlLimitMajor,
    setAqlLimitMinor: aqlCalculatorActions.setAqlLimitMinor,
    setInspectionLevel: aqlCalculatorActions.setInspectionLevel,
    setMinOrderQty: aqlCalculatorActions.setMinOrderQty,
  },
)(Form);
